<template>
  <Modal :show-modal="showRenameModal" @close="toggleRenameModal(false)">
    <template #header>
      <h2>
        {{ $t('shared.button.rename_folder') }}
      </h2>
    </template>
    <template #body>
      <div class="modal__inner">
        <input
          v-model="folder.name"
          :placeholder="$t('shared.placeholder.new_name')"
          class="modal__input"
          type="text"
          :class="{ error: nameAlreadyExists }"
        />
      </div>
      <div v-if="nameAlreadyExists" class="warning">
        {{ $t('customer.folder.modal.name_exists') }}
        <font-awesome-icon
          icon="fa-solid fa-triangle-exclamation"
          color="red"
        />
      </div>
    </template>
    <template #footer>
      <BtnPrimary
        :title="$t('shared.button.update')"
        class="modal__btn modal__btn__submit"
        :disabled="enableButton"
        @click="updateFolderName(folder)"
      />
      <BtnSecondary
        :title="$t('shared.button.close')"
        class="modal__btn modal__btn__close"
        @click="toggleRenameModal(false)"
      />
    </template>
  </Modal>
</template>
<script setup>
import Modal from '@/components/shared/Modal'
import BtnPrimary from '@/components/shared/btn/BtnPrimary'
import BtnSecondary from '@/components/shared/btn/BtnSecondary'
import i18n from '@/i18n'
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t

const folder = ref({
  id: '',
  name: ''
})

const allFolders = computed(() => store.state.folder.allFolders)
const renameFolder = computed(() => store.state.workspace.renameFolder)
const showRenameModal = computed(() => store.state.modals.showRenameModal)

const enableButton = computed(() => {
  return nameAlreadyExists.value || folder.value.name == null
})
const nameAlreadyExists = computed(() => {
  const foundName = allFolders.value.find(
    (obj) =>
      obj.attributes.name.toUpperCase() === folder.value.name.toUpperCase() &&
      obj.attributes.name.toUpperCase() != renameFolder.value.name.toUpperCase()
  )
  if (foundName) {
    return true
  } else return false
})

const toggleRenameModal = () => store.commit('modals/toggleRenameModal')
const updateFolderName = (payload) =>
  store.dispatch('workspace/updateFolderName', payload)

watch(
  () => showRenameModal.value,
  (isOpen) => {
    if (isOpen) {
      folder.value.id = renameFolder.value.id
      folder.value.name = renameFolder.value.name
    }
  }
)
</script>
<style lang="scss" scoped>
.modal__inner {
  display: flex;
  flex-direction: column;
}

.modal__input {
  padding: 10px !important;
  border: 1px solid #cccccc;
  border-radius: 2.5px;
  outline: none;
  &:hover {
    border: 1px solid #2c3fd5 !important;
  }

  &:focus-within {
    border: 1px solid #0d1fb8 !important;
  }
  &.error {
    &:hover {
      border: 1px solid red !important;
    }

    &:focus-within {
      border: 1px solid red !important;
    }
  }
}

.modal__btn {
  cursor: pointer;
}

.modal__btn__submit {
  width: 100%;
}

.modal__btn__close {
  width: 100%;
}
.warning {
  margin-left: 5px;
  margin-top: 5px;
  color: #eb2f2f;
  font-size: 14px;
}
.error {
  :deep(.field__container) {
    &:hover {
      border: none !important;
      outline: none !important;
    }
    &:focus-within {
      border: none !important;
      outline: none !important;
    }

    &:active {
      border: none !important;
      outline: none !important;
    }
  }

  :deep(.field__input) {
    border: 1px solid red !important;
    outline: none !important;
    &:focus-within {
      border: 1px solid red !important;
      outline: none !important;
    }
    &:hover {
      border: 1px solid red !important;
      outline: none !important;
    }
    &:active {
      border: 1px solid red !important;
      outline: none !important;
    }
  }
}
</style>
